import { useEffect, useState, useRef } from "react";
import TagCloud from "TagCloud";
import AnimatedLetters from "../AnimatedLetters/AnimatedLetters";
import "./Skill.scss";
import { Outlet } from "react-router-dom";

function Skill() {
  const [letterClass, setLetterClass] = useState("text-animate");
  const contentRef = useRef(null);

  useEffect(() => {
    const isTouchDevice = window.matchMedia("(hover: none) and (pointer: coarse)").matches;
    const radius = window.innerWidth < 768 ? 180 : window.innerWidth < 1200 ? 280 : 400;

    const myTags = [
      "C/C++",
      "JavaScript",
      "Java",
      "SQL",
      "HTML/CSS",
      "NodeJS",
      "ExpressJS",
      "ReactJS",
      "REST API",
      "Socket.io",
      "WebRTC",
      "Tailwind CSS",
      "MongoDB",
      "MySQL",
      "PostgreSQL",
      "SQLite",
      "Redis",
      "Git",
      "GitHub",
      "VS Code",
      "Gemini API",
      "Stripe API",
    ];

    const tagCloud = TagCloud(".content", myTags, {
      radius,
      maxSpeed: "fast",
      initSpeed: "fast",
      direction: 135,
      keep: true,
    });

    let currentScale = 1;
    let ticking = false;

    const updateTransform = () => {
      if (contentRef.current) {
        contentRef.current.style.transform = `translateY(-50%) scale(${currentScale})`;
      }
      ticking = false;
    };

    const handleWheel = (e) => {
      e.preventDefault();
      const zoomSpeed = 0.0015;
      currentScale += e.deltaY * -zoomSpeed;
      currentScale = Math.min(Math.max(0.4, currentScale), 3);

      if (!ticking) {
        window.requestAnimationFrame(updateTransform);
        ticking = true;
      }
    };

    const sphereContainer = contentRef.current;
    if (sphereContainer && !isTouchDevice) {
      sphereContainer.addEventListener("wheel", handleWheel, {
        passive: false,
      });
    }
    const timer = setTimeout(() => {
      setLetterClass("text-animate-hover");
    }, 4000);

    return () => {
      clearTimeout(timer);
      if (tagCloud && typeof tagCloud.destroy === "function") {
        tagCloud.destroy();
      }
      if (sphereContainer && !isTouchDevice) {
        sphereContainer.removeEventListener("wheel", handleWheel);
      }
    };
  }, []);

  return (
    <>
      <div className="container skill-page">
        <span className="tags top-html">&lt;/html&gt;</span>
        <span className="tags top-tags">&lt;body&gt;</span>
        <div className="text-zone">
          <h1>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={["M", "y", " ", "S", "k", "i", "l", "l", "s"]}
              idx={15}
            />
          </h1>

          <div className="skills-container">
            <div className="skill-category">
              <h3 className="category-title">Languages</h3>
              <div className="skill-tags">
                <span className="skill-tag">C/C++</span>
                <span className="skill-tag">JavaScript</span>
                <span className="skill-tag">Java</span>
                <span className="skill-tag">SQL</span>
                <span className="skill-tag">HTML/CSS</span>
              </div>
            </div>

            <div className="skill-category">
              <h3 className="category-title">Frameworks / Libraries</h3>
              <div className="skill-tags">
                <span className="skill-tag">NodeJS</span>
                <span className="skill-tag">ExpressJS</span>
                <span className="skill-tag">ReactJS</span>
                <span className="skill-tag">REST API</span>
                <span className="skill-tag">Socket.io</span>
                <span className="skill-tag">WebRTC</span>
                <span className="skill-tag">Tailwind CSS</span>
              </div>
            </div>

            <div className="skill-category">
              <h3 className="category-title">Databases</h3>
              <div className="skill-tags">
                <span className="skill-tag">MongoDB</span>
                <span className="skill-tag">MySQL</span>
                <span className="skill-tag">PostgreSQL</span>
                <span className="skill-tag">SQLite</span>
                <span className="skill-tag">Redis</span>
              </div>
            </div>

            <div className="skill-category">
              <h3 className="category-title">Developer Tools &amp; Cloud</h3>
              <div className="skill-tags">
                <span className="skill-tag">Git</span>
                <span className="skill-tag">GitHub</span>
                <span className="skill-tag">Postman</span>
                <span className="skill-tag">Docker</span>
                <span className="skill-tag">VS Code</span>
              </div>
            </div>
          </div>
        </div>
        <Outlet />
        <div ref={contentRef} className="content"></div>
        <div className="scroll-hint">Scroll here to zoom in and zoom out</div>
        <span className="tags bottom-tags">
          &lt;/body&gt;
          <br />
          <span className="bottom-tag-html">&lt;/html&gt;</span>
        </span>
      </div>
    </>
  );
}

export default Skill;